import React from 'react';
import { FileText, Users, Code, Plug } from 'lucide-react';
import './ProofTabNavigation.css';

const ProofTabNavigation = ({ activeTab, setActiveTab, proofT, hideTechStack = false, hideIntegrationsTab = false }) => {
  return (
    <>
      {/* Desktop Tab Navigation */}
      <div className="tab-navigation desktop-tabs">
        <button 
          className={`tab-button ${activeTab === 'case-studies' ? 'active' : ''}`}
          onClick={() => setActiveTab('case-studies')}
        >
          {proofT('tabs.caseStudies')}
        </button>
        <button 
          className={`tab-button ${activeTab === 'partnerships' ? 'active' : ''}`}
          onClick={() => setActiveTab('partnerships')}
        >
          {proofT('tabs.strategicPartners')}
        </button>
        {!hideTechStack && (
        <button 
          className={`tab-button ${activeTab === 'tech-stack' ? 'active' : ''}`}
          onClick={() => setActiveTab('tech-stack')}
        >
          {proofT('tabs.technologyStack')}
        </button>
        )}
        {!hideIntegrationsTab && (
        <button 
          className="tab-button disabled"
          disabled
        >
          {proofT('tabs.integrations')}
        </button>
        )}
      </div>
      
      {/* Mobile Icon Navigation */}
      <div className="mobile-tab-navigation">
        <button 
          className={`mobile-tab-icon ${activeTab === 'case-studies' ? 'active' : ''}`}
          onClick={() => setActiveTab('case-studies')}
          aria-label={proofT('ariaLabels.caseStudies')}
          title={proofT('ariaLabels.caseStudies')}
        >
          <FileText size={20} strokeWidth={2} />
        </button>
        <button 
          className={`mobile-tab-icon ${activeTab === 'partnerships' ? 'active' : ''}`}
          onClick={() => setActiveTab('partnerships')}
          aria-label={proofT('ariaLabels.strategicPartners')}
          title={proofT('ariaLabels.strategicPartners')}
        >
          <Users size={20} strokeWidth={2} />
        </button>
        {!hideTechStack && (
        <button 
          className={`mobile-tab-icon ${activeTab === 'tech-stack' ? 'active' : ''}`}
          onClick={() => setActiveTab('tech-stack')}
          aria-label={proofT('ariaLabels.technologyStack')}
          title={proofT('ariaLabels.technologyStack')}
        >
          <Code size={20} strokeWidth={2} />
        </button>
        )}
        {!hideIntegrationsTab && (
        <button 
          className="mobile-tab-icon disabled"
          disabled
          aria-label={proofT('ariaLabels.integrations')}
          title={proofT('ariaLabels.integrations')}
        >
          <Plug size={20} strokeWidth={2} />
        </button>
        )}
      </div>
    </>
  );
};

export default ProofTabNavigation;






